import { render, staticRenderFns } from "./DamaNews.vue?vue&type=template&id=59255a6a&"
import script from "./DamaNews.vue?vue&type=script&lang=js&"
export * from "./DamaNews.vue?vue&type=script&lang=js&"
import style0 from "./DamaNews.vue?vue&type=style&index=0&id=59255a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports